try {
    window.$ = window.jQuery = require('jquery');
    window.Popper = require('popper.js').default;

    require('bootstrap');
} catch (e) {}

// import Vue from 'vue';
import axios from 'axios';
import jaliliMoment from 'jalali-moment';
jaliliMoment.locale('fa');
import SweetAlert from 'sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';



// window.Vue = Vue;
window.jaliliMoment = jaliliMoment;
window.axios = axios;
window.swal = SweetAlert;

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
let token = document.head.querySelector('meta[name="csrf-token"]');

if (token) {
    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
} else {
    console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
}


/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

// import Echo from 'laravel-echo';
//
// window.Pusher = require('pusher-js');
//
// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: 'af8ef4d408e32db8cdd6',
//     cluster: 'ap3',
//     forceTLS: true
// });
//
// window.Echo.channel('users').listen('UserProfileUpdated', event => {
//     console.log('Ok');
//     console.log(event);
// })
